import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take, filter, map } from 'rxjs/operators';

import { RootState } from '../reducers';
import { getSignedInUser } from '../selectors/auth.selectors';
import { Log } from '../utils/log';
import { navigate } from '../actions/core.actions';
import { RoutingPathResolver } from 'src/app/app-routing-path-resolver';
import { AuthGuard } from './auth.guard';
import { TRY_ORGANIZATION_ID } from '../resources/config';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TryGuard extends AuthGuard {
  constructor(protected store: Store<RootState>) {
    super(store);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.findSignedInUserIfNeeded();

    return this.store.select(getSignedInUser).pipe(
      filter(it => it != null),
      take(1),
      map(user => {
        let isTry = false;
        const authenticated = user !== 'none';

        if (!authenticated) {
          Log.warn(this.constructor.name, `認証されていません`);
          localStorage.setItem('btosGotoUrl', state.url);
          const url = RoutingPathResolver.resolveSignIn();
          this.store.dispatch(navigate({ url, extras: { replaceUrl: true } }));
        } else {
          if (user !== 'none' && user.organization !== TRY_ORGANIZATION_ID) {
            Log.warn(this.constructor.name, `アクセスできないユーザです`);
            const url = RoutingPathResolver.resolveTop();
            this.store.dispatch(navigate({ url, extras: { replaceUrl: true } }));
          } else {
            isTry = true;
          }
        }

        return authenticated && isTry;
      })
    );
  }
}
